import { uaGetInfo } from './appInfo';

export const islp = () => !!window.ENV_INFO?.islp;

export const icfo = () => !!window.ENV_INFO?.icfo;

const searchParams = () => new URLSearchParams(window.location.search);

export const queryIslp = () => searchParams().get('islp') === '1';

export const isLowDevice = () => {
    return islp() || icfo() || queryIslp();
};

export function isLowDeviceFitSSR() {
    const { islp, icfo } = uaGetInfo();
    // TODO: 后续需要看下增加queryIslp的兼容，现在因为window挂了，暂时无诉求
    return islp === '1' || icfo === '1';
}
